import { render } from "./mentalHealthResource.vue?vue&type=template&id=14001b82&scoped=true"
import script from "./mentalHealthResource.vue?vue&type=script&lang=js"
export * from "./mentalHealthResource.vue?vue&type=script&lang=js"

import "./mentalHealthResource.vue?vue&type=style&index=0&id=14001b82&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14001b82"]])

export default __exports__